import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles()(({ brandColors, spacing, typography }) => ({
  categoryPill: {
    padding: `${typography.pxToRem(12)} ${spacing(1)}`,
    border: 'none',
    borderRadius: typography.pxToRem(32),
    color: brandColors.black,
    background: brandColors.white,
    cursor: 'pointer',

    '&:hover': {
      background: brandColors.tintsHeroBlue80,
    },
  },
  categoryPillActive: {
    background: brandColors.primaryMain,
    color: brandColors.white,

    '&:hover': {
      background: brandColors.mediumBlue,
    },
  },
  categoryPillNarrow: {
    padding: `${spacing(-1)} ${spacing(0)}`,
  },
}));

export default useStyles;
